import {
  DigitalPublicationSection,
  IDigitalPublicationSection,
} from "./i-digital-publication-section";

export interface IDigitalPublicationSectionEvent {
  index: number;
  value: IDigitalPublicationSection;
}

export class DigitalPublicationSectionEvent
  implements IDigitalPublicationSectionEvent
{
  constructor(public index: number, public value: IDigitalPublicationSection) {}
}
